import React, { useContext } from 'react'

import { Checkbox, Column } from '@vividseats/vivid-ui-kit'

import filterContext from '@/components/pages/production/components/context'
import ListingsContext from '@/context/listings'

import PriceSlider from './price-slider'

const FiltersPrice: React.FC = () => {
    const {
        state: filterState,
        dispatch: { onShowAllInPriceChangeAction: onShowAllInPriceChange },
    } = useContext(filterContext)

    const { selectors: listingsSelectors } = useContext(ListingsContext)
    const { showAip } = listingsSelectors

    return (
        <>
            {showAip && (
                <Column mb={1}>
                    <Checkbox
                        label="Show prices with estimated fees"
                        checked={filterState.showAllInPrice}
                        boxSize="xs"
                        data-testid="show-all-in-price-check"
                        onChange={onShowAllInPriceChange}
                    ></Checkbox>
                </Column>
            )}
            <PriceSlider />
        </>
    )
}

export default FiltersPrice
